import React from 'react';

//styles
import { IconWrapper } from './PreviewAndDownload.styled';
//assets
import { FileIcon, DownloadIcon } from 'assets/icons';
//styles
import { Flex } from 'components/styled/Flex';
import { useTheme } from 'styled-components';

export const PreviewAndDownload = () => {
  const { colors } = useTheme();

  return (
    <Flex justifyContent="space-between">
      <IconWrapper>
        <FileIcon />
      </IconWrapper>
      <IconWrapper>
        <DownloadIcon stroke={colors.black_60} />
      </IconWrapper>
    </Flex>
  );
};
